import { render, staticRenderFns } from "./wf-document-details-edit.vue?vue&type=template&id=6ab35624&scoped=true&"
import script from "./wf-document-details-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-document-details-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-document-details-edit.vue?vue&type=style&index=0&id=6ab35624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab35624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
